import React from 'react'
import sanityClient from '../../client'
import imageUrlBuilder from '@sanity/image-url'

export default function SkillsList(props) {

    const builder = imageUrlBuilder(sanityClient)

    function urlFor(source) {
        return builder.image(source)
    }


    return (
        <ul className="skills-list">
            {props.skillsList.map((skill) => (
                <li className="skills-list__item">
                    <img src={urlFor(skill.technologyLogo)} />
                    {skill.technologyName}
                </li>
            ))}
        </ul>
    )
}